//Handles toggling active state on jump links
document.addEventListener('DOMContentLoaded', function () {
  const jumpList = document.querySelector('.event-summary-three-col .jump-links__list');
  if (jumpList) {
    const links = jumpList.querySelectorAll('li');
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        links.forEach(function (otherLink) {
          otherLink.classList.remove('active');
          otherLink.classList.add('inactive');
        });
        this.classList.remove('inactive');
        this.classList.add('active');
      });
    });
  }
});
